// Seeded RNG (mulberry32). Deterministic so a match can be replayed/verified —
// the same property the backend sim will need for authoritative replays.

export class JKGameRng {
  private state: number

  constructor(seed: number) {
    // Avoid a zero state.
    this.state = (seed >>> 0) || 0x9e3779b9
  }

  /** float in [0, 1) */
  next(): number {
    this.state |= 0
    this.state = (this.state + 0x6d2b79f5) | 0
    let t = Math.imul(this.state ^ (this.state >>> 15), 1 | this.state)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }

  /** integer in [min, max] inclusive */
  int(min: number, max: number): number {
    if (max < min) return min
    return min + Math.floor(this.next() * (max - min + 1))
  }

  /** true with probability p (0..1) */
  chance(p: number): boolean {
    return this.next() < p
  }

  /** percent roll: true if a d100 lands under `pct` (0..100) — mirrors legacy rand(0,99) < x */
  pct(pct: number): boolean {
    return this.int(0, 99) < pct
  }

  pick<T>(arr: readonly T[]): T {
    return arr[this.int(0, arr.length - 1)]
  }

  /** in-place Fisher–Yates shuffle */
  shuffle<T>(arr: T[]): T[] {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = this.int(0, i)
      ;[arr[i], arr[j]] = [arr[j], arr[i]]
    }
    return arr
  }
}
